<template>
    
    <div>
        
        <img 
            :src="icon.logo" 
            class="card-logo"
        />  
    </div>
</template>

<script>

    import { toRefs, reactive } from "vue";

    import logoIcon from "@/assets/logo.png";

    export default {
        name: "Footer",
        setup() {

            const state = reactive({
                icon: {
                    logo: logoIcon
                }
            });

            return {
                ...toRefs(state)
            };
        }
    }
</script>

<style lang="scss" scoped>

    .card-logo {
        height: auto;
        position: fixed;
        bottom: 5%;
    }

    @media screen and (min-height: 800px) {
        .card-logo {
            width: 20rem;
            left: calc((100% - 20rem) / 2);
        }
    }

    @media screen and (max-height: 800px) {
        
        .card-logo {
            width: 15rem;
            left: calc((100% - 15rem) / 2);
        }
    }
</style>